import React from 'react';
import ReactDOM from 'react-dom/client';
import { StatusDashboard } from './StatusDashboard';
import './index.css';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <StatusDashboard />
  </React.StrictMode>
);
